import React from 'react';
import {Route} from 'react-router-dom'


const PublicRoute = ({component, ...rest}) => {
    const renderMergedProps = (component, ...rest) => {
        const finalProps = Object.assign({}, ...rest);
        return (
            React.createElement(component, finalProps)
        );
    };

    return (
        <Route {...rest} render={routeProps => {
            return (
                renderMergedProps(component, routeProps, rest)
            );
        }}/>
    );
};

export default PublicRoute;


// WEBPACK FOOTER //
// ./src/components/route/PublicRoute.js